import React, {
  Fragment,
  useState,
  useCallback,
  useEffect,
} from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col,
  InputGroup, InputGroupText,
  UncontrolledTooltip,
  FormFeedback,
} from "reactstrap";
import {
  STEP_2_UPDATE_DOCUMENTS_ARRAY,
  SET_VARIABLES_LIST,
} from "../../../redux/actions/ActionTypes";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import shortid from "shortid";
import {
  SingleStringFirstLetterCaps,
  getAlertToast,
} from "../../../utils/functions/CustomFunctions";
import {
  DOCUMENT_VARIABLE_LIST_URL,
  DOCUMENT_VARIABLE_CREATE_URL,
} from "../../../utils/APIEndpoints";
import { authHeader } from "../../../utils/functions/CoreFunctions";
import API from "../../../redux/actions/API";
import Swal from "sweetalert2";
import CustomLoader from "../../common/CustomLoader";

function PlaceholderBuildDialog(props) {
  const {
    CreateDocumentForm = {},
    dispatch,
    className,
    dialogFlag,
    dialogClose,
    documentIndex,
    elements: currentDocElements = [],
    VariantsListReducer = {},
  } = props;

  //Default Field Sizes
  const defaultWidthHeightValues = {
    Text: { width: 100, height: 27 },
    Image: { width: 100, height: 100 },
    Signature: { width: 170, height: 50 },
    Checkbox: { width: 20, height: 20 },
    Variable: { width: 100, height: 27 },
    Number: { width: 100, height: 27 },
    Date: { width: 100, height: 27 },
    MaskedTextBox: { width: 100, height: 27 },
  };

  //Checkbox Sizes
  const checkboxImagesSize = {
    Small: 20,
    Medium: 30,
    Large: 40,
  };

  const initialForm = {
    xCord: 0,
    yCord: 0,
    placeholder: "",
    propertyType: "Text",
    fontSize: "9",
    justify: "Left",
    isBold: false,
    isItalic: false,
    isRequired: false,
    width: 100,
    height: 27,
    imageValue: "",
    textValue: "",
    checkboxType: "Tick",
    checkboxSize: "Medium",
    checkboxValue: true,
    variableId: "",
    variableLabel: "",
    variableFee: 0,
    variableCount: 0,
    variableTypeId: 0,
    isNonDisplayVariable: false,
    hidePlaceholder: false,
    //
    addToagencyfee: true,
    characterLimit: 10,
    allowPastDate: false,
    maskedvalue: "",
    maskedvalueold: "",
  };
  //State
  const [formValues, setFormValues] = useState({
    ...initialForm,
    ...dialogFlag,
  });

  const variableFormInitialValues = {
    labelName: "",
    price: "",
  };
  const [variableFormValues, setVariableFormValues] = useState(
    variableFormInitialValues
  );
  const [addVariableToggle, setAddVariableToggle] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);

  const {
    elementId,
    placeholder = "",
    propertyType = "",
    fontSize = "",
    justify = "",
    isBold = false,
    isItalic = false,
    isRequired = false,
    width = "",
    height = "",
    checkboxType = "Tick",
    checkboxSize = "Medium",
    variableId = "",
    hidePlaceholder = false,
    characterLimit = 10,
    allowPastDate = false,
    maskedvalue = "",
    maskedvalueold = "",
    // variableLabel = '',
    // variableFee = 0,
  } = formValues;

  const { labelName = "", price = "" } = variableFormValues;

  const { step2 = {}, step1 = {}, agencyServiceId } = CreateDocumentForm;
  const { allDocuments = [] } = step2;
  const { formInitialValues = {} } = step1;
  const { paymentType = "" } = formInitialValues;
  const { data: variablesList = [] } = VariantsListReducer;
  const [errors, setErrors] = useState({});

  const [stateMasked, setStateMasked] = useState([]);

  //Variables List
  const variablesListArray = variablesList.map(
    (
      {
        feesId,
        labelName,
        price,
        feeVariableTypeId,
        isNonDisplayVariable,
        formula,
      },
      index
    ) => {
      return (
        <option
          data-variable_label={labelName}
          data-variable_fee={price}
          data-varibale_type-id={feeVariableTypeId}
          data-non_display_variable={isNonDisplayVariable}
          value={feesId}
          data-formula={formula}
          key={`var_list_${index}`}
        >
          {`$${price} - ${labelName}`}
        </option>
      );
    }
  );

  //Variable List
  const getVariableList = async () => {
    try {
      // setLoading(true);
      const options = {
        method: "GET",
        url: DOCUMENT_VARIABLE_LIST_URL,
        headers: authHeader(),
        params: {
          agencyServiceId,
        },
      };
      const response = await API(options);
      const { status, feeDetails = [] } = response.data;
      if (status === "Success") {
        dispatch({
          type: SET_VARIABLES_LIST,
          payload: feeDetails,
        });
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        Swal.fire(getAlertToast("error", data.message));
      }
    } finally {
      // setLoading(false);
    }
  };

  // Variable Form Field On Change
  const onVariableFormFieldChange = (event) => {
    const { name, value } = event.target;
    setVariableFormValues({ ...variableFormValues, [name]: value });
  };

  //Save New Variable
  const createNewVariable = async () => {
    if (!labelName) {
      Swal.fire(getAlertToast("error", "Label is required!"));
    } else if (!price || !(parseInt(price) > 0)) {
      Swal.fire(getAlertToast("error", "Fee is required!"));
    } else {
      setButtonLoading(true);
      const options = {
        method: "POST",
        url: DOCUMENT_VARIABLE_CREATE_URL,
        headers: authHeader(),
        data: { labelName, price, agencyServiceId },
      };
      try {
        let response = await API(options);
        const { status, message, feesId = "" } = response.data;
        if (status === "Error") {
          Swal.fire(getAlertToast("error", message));
        } else {
          Swal.fire(getAlertToast("success", "Variable created successfully"));
          getVariableList();
          setVariableFormValues(variableFormInitialValues);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          Swal.fire(getAlertToast("error", data.message));
        }
      } finally {
        setButtonLoading(false);
      }
    }
  };

  // Field Change
  const onFormFieldChange = useCallback((event) => {
    const { name, value } = event.target;
    let findType;

    if (name === "checkboxSize") {
      const { type } = event.currentTarget.dataset;
      findType = type;
    }

    let valueToStore = value;
    let additionalObjects = {};

    if (name === "placeholder") {
      valueToStore = SingleStringFirstLetterCaps(value);
    } else if (name === "propertyType") {
      additionalObjects = {
        width: defaultWidthHeightValues[value].width,
        height: defaultWidthHeightValues[value].height,
        // variableTypeId: 0,
      };
    } else if (name === "checkboxSize") {
      if (findType == "singleProductCheck") {
        additionalObjects = {
          width: value == "Medium" ? 120 : value == "Large" ? 140 : width,
          height: value == "Medium" ? 35 : value == "Large" ? 40 : height,
        };
      } else {
        additionalObjects = {
          width: checkboxImagesSize[value],
          height: checkboxImagesSize[value],
        };
      }
    } else if (name === "variableId") {
      const variableLabel = event.target[
        event.target.selectedIndex
      ].getAttribute("data-variable_label");
      const variableFee =
        event.target[event.target.selectedIndex].getAttribute(
          "data-variable_fee"
        );
      const variableTypeId = event.target[
        event.target.selectedIndex
      ].getAttribute("data-varibale_type-id");
      const isNonDisplayVariable = event.target[
        event.target.selectedIndex
      ].getAttribute("data-non_display_variable");

      additionalObjects = {
        variableLabel,
        variableFee,
        variableTypeId,
        isNonDisplayVariable,
      };
    }

    if (name === "width") {
      if (new RegExp(/^\d*[1-9]\d*$/).test(value)) {
        setErrors({ ...errors, width: false });
      } else {
        setErrors({ ...errors, width: true });
      }
    }
    if (name === "height") {
      if (new RegExp(/^\d*[1-9]\d*$/).test(value)) {
        setErrors({ ...errors, height: false });
      } else {
        setErrors({ ...errors, height: true });
      }
    }

    if (name != "characterLimit") {
      setFormValues((prevState) => {
        return {
          ...prevState,
          [name]: valueToStore,
          ...additionalObjects,
        };
      });
    } else {
      const reg = /^\d+$/;
      // const reg = /^[0-9]+$/;
      if (value == "" || reg.test(value)) {
        setFormValues((prevState) => {
          return {
            ...prevState,
            [name]: valueToStore,
            ...additionalObjects,
          };
        });
      }
    }
  }, []);

  useEffect(() => {
    if (formValues.maskedvalue == "") {
      let arr = [];
      for (let i = 0; i < 10; i++) {
        arr.push("");
      }
      setStateMasked(arr);
    }
  }, [formValues]);

  useEffect(() => {
    if (formValues.maskedvalue !== "") {
      var newarr = formValues.maskedvalue.split("");
      setStateMasked(newarr);
    }
  }, []);

  //Checkbox Value Change
  const onCheckBoxValueChange = useCallback(({ target: { name, checked } }) => {
    setFormValues((prevState) => {
      return {
        ...prevState,
        [name]: checked,
      };
    });
  }, []);

  const onFormvaluechange = (e, i) => {
    var { maxLength, value, name } = e.target;
    const [fieldName, fieldIndex] = name.split("-");
    let fieldIntIndex = parseInt(fieldIndex, 10);

    if (value.indexOf(" ") > -1) {
      value = "-";
    }

    // Check if no of char in field == maxlength
    if (value.length >= maxLength) {
      // It should not be last input field
      if (fieldIntIndex < characterLimit) {
        // Get the next input field using it's name
        const nextfield = document.querySelector(
          `input[name=field-${fieldIntIndex + 1}]`
        );
        // If found, focus the next field
        if (nextfield !== null) {
          nextfield.focus();
        }
      }
    }

    let newArr = [...stateMasked];
    newArr[fieldIntIndex] = value;
    setStateMasked(newArr);

    let values = "";
    newArr.forEach((ele, j) => {
      if (ele != undefined && ele != " " && ele != null && ele.length >= 1) {
        values = values + ele?.toString();
      } else {
        values = values + "-";
      }
    });

    // const sumWithInitial = newArr.reduce(
    //   (a, b) => typeof(a) !== undefined ? a.toString() : "" + typeof(b) !== undefined ? b.toString() : ""
    //       );


    const newobj = {
      ...formValues,
      maskedvalue: values,
      maskedvalueold: values,
    };

    setFormValues(newobj);
  };

  const handleKeyDown = (event, i) => {
    var { maxLength, value, name } = event.target;
    const [fieldName, fieldIndex] = name.split("-");

    let fieldIntIndex = parseInt(fieldIndex, 10);
    if (value == " ") {
      onFormvaluechange(event);
    }

    if (event.key === "Backspace") {
      if (value) {
        const prefield = document.querySelector(
          `input[name=field-${fieldIntIndex}]`
        );
        if (prefield !== null) {
          prefield.focus();
        }
      } else {
        const prefield = document.querySelector(
          `input[name=field-${fieldIntIndex - 1}]`
        );
        if (prefield !== null) {
          prefield.focus();
        }
      }

      let newArr = [...stateMasked];
      newArr[i] = value;
      setStateMasked(newArr);

      if (value.indexOf(" ") > -1) {
        console.log("space");
        value = "-";
      }

      let values = "";
      newArr.forEach((ele) => {
        if (ele != undefined && ele != " " && ele != null && ele.length >= 1) {
          values = values + ele.toString();
        } else {
          values = values + " ";
        }
      });

      const newobj = {
        ...formValues,
        maskedvalue: values,
        maskedvalueold: values,
      };

      setFormValues(newobj);

      // 👇️ your logic here
    }
  };

  // Form Submit
  const onFormSubmit = (event) => {
    event.preventDefault();
    // let inputValues = [];
    // for (let i=0; i < characterLimit ; i++) {
    //  let inputvalue =  document.querySelector(
    //     `input[name=field-${i}]`
    //   );
    //   if(inputvalue){
    //     inputValues.push(inputvalue.value);
    //   }
    // }

    // let mvalues = inputValues.join('');

    //     let values = "";
    //     stateMasked.forEach((ele)=>{
    //   if(ele != undefined){
    //     values = values + ele.toString()
    //   }
    //   else{
    //     values = values + " "
    //   }
    // })

    // const newobj ={
    //   ...formValues,
    //   "maskedvalue":stateMasked,
    //   "maskedvalueold":stateMasked,
    // }

    // setFormValues(newobj);


    let dialogElement = Object.assign({}, formValues);

    if (elementId) {
      let targetElementIndex = currentDocElements.findIndex(
        (e) => e.elementId === elementId
      );
      //   dialogElement.width = dialogElement.placeholder.split('').length * 8;
      currentDocElements[targetElementIndex] = dialogElement;
    } else {
      //update position of text and image based on height fontsize and image height.
      // if (dialogElement.propertyType == 'Text') {
      //   dialogElement.xCord -= 6;
      //   dialogElement.yCord = dialogElement.yCord - 7 - fontSize;
      //    //  dialogElement.width = dialogElement.placeholder.split('').length * 8;
      // } else if (dialogElement.propertyType == 'Image') {
      //   dialogElement.yCord = dialogElement.yCord - dialogElement.height;
      // }

      currentDocElements.push({
        ...dialogElement,
        elementId: shortid.generate(),
      });
    }

    allDocuments[documentIndex].elements = currentDocElements;

    dispatch({
      type: STEP_2_UPDATE_DOCUMENTS_ARRAY,
      payload: allDocuments,
    });

    dialogClose();
  };

  // Remove Element
  const onDeleteElementClick = (elementId) => {
    let updatedElements = allDocuments[documentIndex].elements.filter(
      (element) => element.elementId !== elementId
    );
    allDocuments[documentIndex].elements = updatedElements;
    dispatch({
      type: STEP_2_UPDATE_DOCUMENTS_ARRAY,
      payload: allDocuments,
    });
    dialogClose();
  };

  //Add new variablle toggle
  const addNewVariableToggle = () => {
    setAddVariableToggle(!addVariableToggle);
  };

  return (
    <Fragment>
      <div>
        <Modal
          isOpen={!!dialogFlag}
          fade={false}
          toggle={dialogClose}
          className={className}
          style={{ maxWidth: "800px" }}
          backdrop="static"
        >
          <ModalHeader toggle={dialogClose}>Create Element</ModalHeader>
          <ModalBody>
            <Form onSubmit={onFormSubmit} id={"popupform_" + documentIndex}>
              <Row>
                {propertyType !== "Checkbox" && propertyType !== "Variable" && (
                  <Col md={6}>
                    <FormGroup>
                      <Label for="placeholder">Placeholder</Label>
                      <Input
                        required
                        type="text"
                        name="placeholder"
                        id="placeholder"
                        placeholder="Enter placeholder text "
                        value={placeholder}
                        onChange={onFormFieldChange}
                      />
                    </FormGroup>
                  </Col>
                )}
                <Col md={6}>
                  <FormGroup>
                    <Label for="propertySelect">Type</Label>
                    <Input
                      type="select"
                      name="propertyType"
                      id="propertySelect"
                      value={propertyType}
                      onChange={onFormFieldChange}
                    >
                      <option value="Text">Text</option>
                      <option value="Image">Image</option>
                      <option value="Checkbox">Checkbox</option>
                      <option value="Signature">Signature</option>
                      {paymentType === "Variable" && (
                        <option value="Variable">Variable</option>
                      )}
                      <option value="Number">Number</option>
                      <option value="Date">Date</option>
                      <option value="MaskedTextBox">Masked text Box</option>
                    </Input>
                  </FormGroup>
                </Col>

                {propertyType === "Variable" && (
                  <Fragment>
                    <Col md={4}>
                      <FormGroup>
                        <Label for="feesSelect">Select Variable</Label>
                        <Input
                          required
                          type="select"
                          name="variableId"
                          id="feesSelect"
                          value={variableId}
                          onChange={onFormFieldChange}
                        >
                          <option value="">Select Variable</option>
                          {variablesListArray}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={2}>
                      <Button
                        id="add_new_variable_flag"
                        style={{ margin: "2.1rem 5rem 0rem 0rem" }}
                        color="primary"
                        onClick={addNewVariableToggle}
                      >
                        <i
                          className="fas fa-plus"
                          style={{ paddingRight: 0 }}
                        />
                      </Button>
                      <UncontrolledTooltip
                        placement="top"
                        target="add_new_variable_flag"
                      >
                        Add New Variable
                      </UncontrolledTooltip>
                    </Col>

                    {formValues.variableTypeId != 1 && (
                      <>
                        <Col md={3}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="isRequired"
                                checked={isRequired}
                                onChange={onCheckBoxValueChange}
                              />{" "}
                              Required
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="hidePlaceholder"
                                checked={hidePlaceholder}
                                onChange={onCheckBoxValueChange}
                              />{" "}
                              Hide Placeholder
                            </Label>
                          </FormGroup>
                        </Col>
                      </>
                    )}
                  </Fragment>
                )}
              </Row>
              {propertyType === "Variable" && addVariableToggle && (
                <Row>
                  <Col md={1} />
                  <Col md={4}>
                    <FormGroup>
                      <Label for="labelName">Label Name</Label>
                      <Input
                        type="text"
                        name="labelName"
                        id="labelName"
                        placeholder="Enter Label Name "
                        value={labelName}
                        onChange={onVariableFormFieldChange}
                      />
                    </FormGroup>
                  </Col>
                  <Col md={4}>
                    <FormGroup>
                      <Label for="price">Fee ($)</Label>
                      <InputGroup>
                        
                          <InputGroupText>$</InputGroupText>
                        
                        <Input
                          type="number"
                          min="1"
                          name="price"
                          id="price"
                          placeholder="Enter Fee"
                          onChange={onVariableFormFieldChange}
                          value={price}
                        />
                      </InputGroup>
                    </FormGroup>
                  </Col>
                  <Col md={2}>
                    <Button
                      color="danger"
                      onClick={createNewVariable}
                      style={{ marginTop: "2.1rem" }}
                    >
                      {buttonLoading && (
                        <CustomLoader loading={buttonLoading} />
                      )}{" "}
                      Save
                    </Button>
                  </Col>
                  <Col md={1} />
                </Row>
              )}
              {formValues.variableTypeId == 1 &&
                propertyType === "Variable" && (
                  <Fragment>
                    <Row>
                      <Col md={6}>
                        <FormGroup>
                          <Label for="checkboxType">Checkbox Type</Label>
                          <Input
                            type="select"
                            name="checkboxType"
                            id="checkboxType"
                            value={checkboxType}
                            onChange={onFormFieldChange}
                          >
                            {/* <option value="Cross">Cross</option> */}
                            <option value="Tick">Tick</option>
                            {/* <option value="Dot">Dot</option> */}
                          </Input>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup>
                          <Label for="checkboxSize">Size</Label>
                          <Input
                            type="select"
                            name="checkboxSize"
                            id="checkboxSize"
                            value={checkboxSize}
                            onChange={onFormFieldChange}
                            data-type="singleProductCheck"
                          >
                            <option value="Small">Small</option>
                            <option value="Medium">Medium</option>
                            <option value="Large">Large</option>
                          </Input>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Row>
                      <>
                        <Col md={3}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="isRequired"
                                checked={isRequired}
                                onChange={onCheckBoxValueChange}
                              />{" "}
                              Required
                            </Label>
                          </FormGroup>
                        </Col>
                        <Col md={3}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="hidePlaceholder"
                                checked={hidePlaceholder}
                                onChange={onCheckBoxValueChange}
                              />{" "}
                              Hide Placeholder
                            </Label>
                          </FormGroup>
                        </Col>
                      </>
                    </Row>
                  </Fragment>
                )}

              {(propertyType === "Text" ||
                propertyType === "Number" ||
                propertyType === "Date" ||
                propertyType === "MaskedTextBox") && (
                <Fragment>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="fontSize">Font Size</Label>
                        <Input
                          type="select"
                          name="fontSize"
                          id="fontSize"
                          value={fontSize}
                          onChange={onFormFieldChange}
                        >
                          {[9, 11, 13, 15, 17, 19].map((value, index) => (
                            <option value={value} key={`fsize_${index}`}>
                              {value}
                            </option>
                          ))}
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="justifySelect">Align</Label>
                        <Input
                          type="select"
                          name="justify"
                          id="justifySelect"
                          value={justify}
                          onChange={onFormFieldChange}
                        >
                          <option value="Left">Left</option>
                          <option value="Center">Center</option>
                          <option value="Right">Right</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    {propertyType === "MaskedTextBox" ? (
                      <>
                        <Col md={6}>
                          <FormGroup>
                            <Label for="characterLimit">Character Limit</Label>
                            <Input
                              type="number"
                              name="characterLimit"
                              id="characterLimit"
                              value={characterLimit}
                              onChange={(e) => {
                                let arr = [];
                                for (let i = 0; i < e.target.value; i++) {
                                  arr.push("");
                                }
                                setStateMasked(arr);

                                onFormFieldChange(e);
                              }}
                              step="1"
                              min="1"
                              pattern="\d+"
                              placeholder="Enter Character Limit"
                            ></Input>
                          </FormGroup>
                        </Col>{" "}
                        <Col md={6}>
                          <FormGroup className="maskedvalue">
                            {(() => {
                              let inputTemplates = [];
                              for (let i = 0; i < characterLimit; i++) {
                                inputTemplates.push(
                                  <>
                                    <Input
                                      type="text"
                                      name={`field-${i}`}
                                      onChange={(e) => {
                                        onFormvaluechange(e, i);
                                      }}
                                      onKeyDown={(e) => {
                                        handleKeyDown(e, i);
                                      }}
                                      // value={maskedvalue ? maskedvalue.charAt(i) !== "" ? maskedvalue.charAt(i) : "" :""}
                                      value={
                                        stateMasked
                                          ? stateMasked[i] !== "-"
                                            ? stateMasked[i]
                                            : ""
                                          : ""
                                      }
                                      maxLength={1}
                                    ></Input>
                                  </>
                                );
                              }
                              return inputTemplates;
                            })()}
                            <span class="result"></span>
                            {/* <Input
                        required
                        type="text"
                        name="placeholder"
                        id="mvalue"                 
                        value={placeholder}
                        onChange={onFormFieldChange}
                        maxlength={characterLimit}
                        max={characterLimit}
                      /> */}
                          </FormGroup>
                        </Col>
                      </>
                    ) : (
                      ""
                    )}
                    <Row style={{ padding: "0px 15px" }}>
                      <Col md={1}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="isBold"
                              checked={isBold}
                              onChange={onCheckBoxValueChange}
                            />{" "}
                            Bold
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={1} style={{ marginLeft: "20px" }}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="isItalic"
                              checked={isItalic}
                              onChange={onCheckBoxValueChange}
                            />{" "}
                            Italic
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={1} style={{ marginLeft: "20px" }}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="isRequired"
                              checked={isRequired}
                              onChange={onCheckBoxValueChange}
                            />{" "}
                            Required
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3} style={{ marginLeft: "48px" }}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="hidePlaceholder"
                              checked={hidePlaceholder}
                              onChange={onCheckBoxValueChange}
                            />
                            Hide Placeholder
                          </Label>
                        </FormGroup>
                      </Col>
                      {propertyType === "Date" ? (
                        <Col md={2.5} style={{ marginLeft: "5px" }}>
                          <FormGroup check>
                            <Label check>
                              <Input
                                type="checkbox"
                                name="allowPastDate"
                                checked={allowPastDate}
                                onChange={onCheckBoxValueChange}
                              />{" "}
                              Allow past date
                            </Label>
                          </FormGroup>
                        </Col>
                      ) : (
                        ""
                      )}
                    </Row>
                  </Row>
                </Fragment>
              )}
              {(propertyType === "Image" || propertyType === "Signature") && (
                <Fragment>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="width">Width in px</Label>
                        <Input
                          type="number"
                          name="width"
                          id="width"
                          placeholder="Width in px"
                          value={width}
                          onChange={onFormFieldChange}
                          invalid={errors.width ? true : false}
                        />
                        <FormFeedback>
                          {errors.width && "Enter Valid Width"}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="placeholder">Height in px</Label>
                        <Input
                          type="number"
                          name="height"
                          id="height"
                          placeholder="Height in px"
                          value={height}
                          onChange={onFormFieldChange}
                          invalid={errors.height ? true : false}
                        />
                        <FormFeedback>
                          {errors.height && "Enter Valid Height"}
                        </FormFeedback>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={2}>
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            name="isRequired"
                            checked={isRequired}
                            onChange={onCheckBoxValueChange}
                          />{" "}
                          Required
                        </Label>
                      </FormGroup>
                    </Col>
                    <Col md={4}>
                      <FormGroup check>
                        <Label check>
                          <Input
                            type="checkbox"
                            name="hidePlaceholder"
                            checked={hidePlaceholder}
                            onChange={onCheckBoxValueChange}
                          />{" "}
                          Hide Placeholder
                        </Label>
                      </FormGroup>
                    </Col>
                  </Row>
                </Fragment>
              )}
              {propertyType === "Checkbox" && (
                <>
                  <Row>
                    <Col md={6}>
                      <FormGroup>
                        <Label for="checkboxType">Checkbox Type</Label>
                        <Input
                          type="select"
                          name="checkboxType"
                          id="checkboxType"
                          value={checkboxType}
                          onChange={onFormFieldChange}
                        >
                          <option value="Cross">Cross</option>
                          <option value="Tick">Tick</option>
                          <option value="Dot">Dot</option>
                        </Input>
                      </FormGroup>
                    </Col>
                    <Col md={3}>
                      <FormGroup>
                        <Label for="checkboxSize">Size</Label>
                        <Input
                          type="select"
                          name="checkboxSize"
                          id="checkboxSize"
                          value={checkboxSize}
                          onChange={onFormFieldChange}
                          data-type="ImageCheck"
                        >
                          <option value="Small">Small</option>
                          <option value="Medium">Medium</option>
                          <option value="Large">Large</option>
                        </Input>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row>
                    <>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="isRequired"
                              checked={isRequired}
                              onChange={onCheckBoxValueChange}
                            />{" "}
                            Required
                          </Label>
                        </FormGroup>
                      </Col>
                      <Col md={3}>
                        <FormGroup check>
                          <Label check>
                            <Input
                              type="checkbox"
                              name="hidePlaceholder"
                              checked={hidePlaceholder}
                              onChange={onCheckBoxValueChange}
                            />{" "}
                            Hide Placeholder
                          </Label>
                        </FormGroup>
                      </Col>
                    </>
                  </Row>
                </>
              )}
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              type="submit"
              form={"popupform_" + documentIndex}
            >
              {elementId ? "Update" : "Create"}
            </Button>{" "}
            <Button color="secondary" onClick={dialogClose}>
              Cancel
            </Button>
            {elementId && (
              <Button
                color="danger"
                onClick={() => onDeleteElementClick(elementId)}
              >
                Delete
              </Button>
            )}
          </ModalFooter>
        </Modal>
      </div>
    </Fragment>
  );
}
const getState = ({ CreateDocumentForm, VariantsListReducer }) => {
  return {
    CreateDocumentForm,
    VariantsListReducer,
  };
};
const mapDispatchToProps = (dispatch) => ({
  ...bindActionCreators(
    {
      //
    },
    dispatch
  ),
  dispatch,
});
export default connect(getState, mapDispatchToProps)(PlaceholderBuildDialog);

